import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HelperFunctionsService } from './helper-functions.service';
import { GlobalConstants } from '../common/global';
import { ErrorMessageService } from './error-message.util';

declare const FB: any;

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  constructor(
    private http: HttpClient,
    private helperFunctions: HelperFunctionsService,
    private readonly errorMessageService: ErrorMessageService
  ) { }

  private errorSubject = new Subject<string>();
  error$ = this.errorSubject.asObservable();

  login(body: any): Observable<any> {
    const options = { withCredentials: true };
    return this.http.post<any>(`${environment.apiUrl}/auth/main/signin`, body, options).pipe(
      map((data) => {
        if(data.token) {
          localStorage.setItem('accessToken' + environment.connId, data.token);
          const token = localStorage.getItem('accessToken' + environment.connId);
          this.connectionLogin(token);
        }
  
        return data;
      }),
      catchError((error) => {
        return error;
      })
    );
  }

  loginWithPin(userId: string, pin: any): Observable<any> {
    const body = { userId: userId, pin: pin };
    const options = { withCredentials: true };
  
    return this.http.post<any>(`${environment.apiUrl}/auth/main/pin-signin`, body, options).pipe(
      map((data) => {
        if(data.success === true) {
          localStorage.setItem('accessToken' + environment.connId, data.token);
          const token = localStorage.getItem('accessToken' + environment.connId);
          this.connectionLogin(token);
        }
  
        return data;
      }),
      catchError((error) => {
        return error;
      })
    );
  }

  connectionLogin(token: any) {
    this.http.post<any>(`${environment.apiUrl}/auth/connect/${environment.connId}`, {}, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    }).subscribe({
      next: data => {             
        localStorage.setItem('accessTokenCentral' + environment.connId, data.token);
        window.location.reload();
      }
    })
  }

  handleCredentialResponse(response: any) {
    const responsePayload = this.decodeJwtResponse(response.credential);

    const body = {
      googleId: responsePayload.sub,
      email: responsePayload.email,
      firstName: responsePayload.given_name,
      lastName: responsePayload.family_name
    };

    if (!body.firstName || !body.lastName) {
      this.errorSubject.next(this.errorMessageService.getErrorMessage('errorMissingData'));
      return;
    }
    
    this.http.post<any>(`${environment.apiUrl}/auth/main/signin-google`, body, GlobalConstants.headers).subscribe({
      next: (data: any) => {
        if(data.token) {
          localStorage.setItem('accessToken' + environment.connId, data.token);
          this.connectionLogin(data.token);
        }
      },
      error: (error) => {
      }
    });
  }

  decodeJwtResponse (token: any) {
    let base64Url = token.split('.')[1];
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    let jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  };

  loadFacebookSDK(): Promise<void> {
    return new Promise<void>((resolve) => {
      (window as any).fbAsyncInit = () => {
        FB.init({
          appId: '451047933216100',
          cookie: true,
          xfbml: false,
          version: 'v18.0'
        });
        resolve();
      };

      const script = document.createElement('script');
      script.src = 'https://connect.facebook.net/en_US/sdk.js';
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    });
  }

  loginWithFacebook(): void {
    FB.login((response: any) => {
      if (response.authResponse) {
        FB.api('/me', { fields: 'id,email,first_name,last_name' }, (userInfo: any) => {  
          const body = {
            id: userInfo.id,
            email: userInfo.email,
            firstName: userInfo.first_name,
            lastName: userInfo.last_name
          };

          if (!body.firstName || !body.lastName) {
            this.errorSubject.next(this.errorMessageService.getErrorMessage('errorMissingData'));
            return;
          }
  
          this.http.post<any>(`${environment.apiUrl}/auth/main/signin-facebook`, body, GlobalConstants.headers)
            .subscribe({
              next: (data: any) => {
                if(data.token) {
                  localStorage.setItem('accessToken' + environment.connId, data.token);
                  this.connectionLogin(data.token);
                }
              },
              error: (err) => {
                console.error('Login error', err);
                //this.errorSubject.next('Došlo je do greške kod Facebook prijave.');
              }
            });
        });
      } else {
        ///this.errorSubject.next('Facebook prijava nije uspjela.');
      }
    }, { scope: 'email,public_profile' });
  }
}
